const styles = (theme) => ({
	statusDot: {
		width: 8,
		height: 8,
		borderRadius: "50%",
		"@keyframes pulse": {
			"0%": {
				transform: "scale(1)",
				opacity: 1,
			},
			"50%": {
				transform: "scale(1.2)",
				opacity: 0.5,
			},
			"100%": {
				transform: "scale(1)",
				opacity: 1,
			},
		},
	},
	accordionTextStatus: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: 1,
	},
	accordionSummary: {
		"& .MuiAccordionSummary-content": {
			minWidth: 0, // Crucial para ellipsis
			overflow: "hidden",
		},
	},
	boxCampos: {
		display: "flex",

		gap: 1,
	},
	boxEnderecoTitle: {
		fontWeight: "bold",
		fontSize: 14,
		whiteSpace: "nowrap",
	},
	boxEnderecoContent: {
		fontSize: 14,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		cursor: "pointer",
	},
	typographyLabel: {
		fontSize: 14,
		cursor: "pointer",
	},
	typhographyTitle: {
		fontWeight: "bold",
		fontSize: 14,
	},
	chipGroup: {
		mt: 1,
		mr: 1,
	},
	contratoChip: (isExpirado) => ({
		border: "0.6px solid",
		color: theme.palette.chip.colorText[isExpirado ? "critical" : "success"],
		bgcolor: theme.palette.chip.background[isExpirado ? "critical" : "success"],
	}),
	icons: {
		fontSize: 18,
		color: theme.palette.primary.main,
	},
});

export default styles;
